import React, { useMemo } from 'react';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';
import { Box, Typography } from '@mui/material';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

function OrdersGraph({ inventoryLevels, rangeStart }) {
  const { data, displayLabels } = useMemo(() => {
    const levels = inventoryLevels || [];
    const start = rangeStart || new Date(0);

    // Orders inferred from day-over-day increases in inventory (restocks).
    const series = levels.map((entry, index) => {
      const date = entry.date.split('T')[0];
      const value = index === 0
        ? 0
        : Math.max(0, entry.quantity - levels[index - 1].quantity);
      return { date, value };
    });

    const filtered = series.filter((d) => new Date(d.date) >= start);
    const labels = filtered.map((d) => d.date);

    return {
      displayLabels: labels,
      data: {
        labels,
        datasets: [{
          label: 'Orders',
          data: filtered.map((d) => d.value),
          fill: false,
          borderColor: '#10b981',
          tension: 0.1,
          pointHitRadius: 5,
          pointHoverRadius: 5,
          pointBackgroundColor: '#10b981',
          borderWidth: 2,
        }],
      },
    };
  }, [inventoryLevels, rangeStart]);

  const options = {
    responsive: true,
    plugins: {
      legend: { position: 'top', labels: { font: { family: 'Inter', size: 12 }, usePointStyle: true, pointStyleWidth: 8 } },
      tooltip: {
        mode: 'index', intersect: false,
        titleFont: { family: 'Inter' }, bodyFont: { family: 'Inter' },
        callbacks: {
          label: (context) => `Orders: ${context.raw}`,
          title: (context) => displayLabels[context[0].dataIndex] || 'Date: N/A',
        },
      },
    },
    interaction: { mode: 'index', intersect: false },
    scales: {
      x: { beginAtZero: true, ticks: { font: { family: 'Inter', size: 10 } }, grid: { color: 'rgba(0,0,0,0.04)' } },
      y: { beginAtZero: true, title: { display: true, text: 'Quantity Ordered', font: { family: 'Inter', size: 11 } }, grid: { color: 'rgba(0,0,0,0.04)' }, ticks: { font: { family: 'Inter', size: 10 } } },
    },
  };

  return (
    <Box>
      <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>Orders</Typography>
      <Line data={data} options={options} />
    </Box>
  );
}

export default OrdersGraph;
